import { Avatar } from "@/components/ui/avatar";
import { Card } from "@/components/ui/card";
import { Text } from "@/components/ui/text";
import { Heading } from "@/components/ui/heading";
import { VStack } from "@/components/ui/vstack";
import { OrganizationQRDTO } from "@/generated/api/models";
import { HStack } from "@/components/ui/hstack";
import { Icon } from "@/components/ui/icon";
import { ChevronRight, QrCode } from "lucide-react-native";

export function RestaurantQRCodesItemMini({ qr }: { qr: OrganizationQRDTO }) {
  return (
    <Card
      size="md"
      variant="filled"
      className="flex-row justify-between w-full items-center"
    >
      <HStack className="gap-4 items-center">
        <Avatar>
          <Icon as={QrCode} size={25} className="stroke-white" />
        </Avatar>
        <VStack className="gap-0">
          <Heading
            size="sm"
            className="text-ellipsis overflow-hidden whitespace-nowrap"
            numberOfLines={1}
            ellipsizeMode="tail"
          >
            {qr.internalCode}
          </Heading>
          {qr.displayName && <Text size="xs">{qr.displayName}</Text>}
        </VStack>
      </HStack>

      <Icon as={ChevronRight} />
    </Card>
  );
}
